import React, { useState, useRef, useEffect } from 'react';
import { DateRange } from 'react-date-range';
import { IoCalendarOutline } from 'react-icons/io5';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { formatDateStaructre } from '../../utils/structure-date-time-utils';



const DateRangePicker = ({ onChange, initialRange }) => {
  const wrapperRef = useRef(null);

  const [dateRange, setDateRange] = useState([
    {
      startDate: initialRange?.startDate || new Date(),
      endDate: initialRange?.endDate || new Date(),
      key: 'selection',
    },
  ]);

  const [showPicker, setShowPicker] = useState(false);

  const handleChange = (ranges) => {
    const selection = ranges.selection;
    setDateRange([selection]);
    onChange({
      startDate: selection.startDate,
      endDate: selection.endDate,
    });
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        onClick={() => setShowPicker((prev) => !prev)}
        className="px-3 py-2 border outline-none rounded-md text-sm bg-white flex items-center gap-2 text-gray-700"
      >
        <IoCalendarOutline className="text-lg text-gray-500" />
        <span className="whitespace-nowrap">
          {dateRange[0]?.startDate && dateRange[0]?.endDate
            ? `${formatDateStaructre(dateRange[0].startDate)} - ${formatDateStaructre(dateRange[0].endDate)}`
            : 'Date Range'}
        </span>
      </button>

      {showPicker && (
        <div className="absolute z-50 mt-2 shadow-lg bg-white">
          <DateRange
            editableDateInputs
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            maxDate={new Date()}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
